import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Step, StepLabel, Stepper } from '@mui/material';
import React, { useEffect } from 'react';
import ConsentPartOneSpanish from './ConsentPartOneSpanish';
import ReleaseHealthInfoSpanish from './ReleaseHealthInfoSpanish';
import DocumentAcknowledgementSpanish from './DocumentAcknowledgementSpanish';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import { RootState } from '../../../../reducers';
import { checkValidation, consentStepsSpanish, setActiveStep, setConsentSuccessful, setOpenSignConsentOneSpanish } from '../../../../store/consentSlice.slice';
import { getConsentFormDocumentByMember } from '../../../../store/assessment.slice';
import ToggleLanguage from '../ToggleLanguage';

const ConsentOneBoxSpanish = () => {
    const dispatch = useAppDispatch();
    const { activeStep, consentSuccessful, digitalSignatureForm, isSaving, openSignConsentOneSpanish } = useSelector((state: RootState) => state.consentSlice);
    const { memberBasicInfo } = useSelector((state: RootState) => state.memberDetail);

    const handleNextStep = () => {
        dispatch(checkValidation(activeStep, digitalSignatureForm, false));
    };

    useEffect(() => {
        if (consentSuccessful) {
            dispatch(setConsentSuccessful(false));
            dispatch(getConsentFormDocumentByMember(memberBasicInfo.Id));
            dispatch(setOpenSignConsentOneSpanish(false));
        }
    }, [consentSuccessful, memberBasicInfo.Id, dispatch]);

    return (
        <Dialog open={openSignConsentOneSpanish} onClose={() => dispatch(setOpenSignConsentOneSpanish(false))} maxWidth="lg" fullWidth>
            <ToggleLanguage />
            <DialogTitle>
                <Stepper alternativeLabel activeStep={activeStep}>
                    {consentStepsSpanish.map((step) => {
                        return (
                            <Step key={step.value}>
                                <StepLabel>{step.label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
            </DialogTitle>
            <DialogContent>
                {activeStep === 0 && <ConsentPartOneSpanish />}
                {activeStep === 1 && <ReleaseHealthInfoSpanish />}
                {activeStep === 2 && <DocumentAcknowledgementSpanish />}
            </DialogContent>
            <DialogActions>
                <Stack direction={'row'} justifyContent={'space-between'} spacing={2} p={2} sx={{ width: '100%' }}>
                    <Button
                        disabled={activeStep === 0}
                        onClick={() => {
                            dispatch(setActiveStep(activeStep - 1));
                        }}
                        sx={{ minWidth: '120px' }}
                        variant="contained"
                    >
                        Anterior
                    </Button>
                    <Button variant="outlined" sx={{ minWidth: '120px' }} onClick={() => dispatch(setOpenSignConsentOneSpanish(false))}>
                        Cancelar
                    </Button>
                    <Button onClick={handleNextStep} sx={{ minWidth: '120px' }} variant="contained" disabled={isSaving}>
                        {activeStep < 2 ? 'Siguiente' : 'Guardar y Finalizar'}
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default ConsentOneBoxSpanish;
